import React, { useState } from 'react';
import {
  FormBox,
  Title,
  InputGroup,
  Label,
  Input,
  Select,
  ButtonGroup,
  Button,
} from './StyledComponents';

const BusinessInfoForm = ({
  companyName,
  setCompanyName,
  businessNumber,
  setBusinessNumber,
  representativeName,
  setRepresentativeName,
  industryType,
  setIndustryType,
  businessCategory,
  setBusinessCategory,
  address,
  setAddress,
  bank,
  accountNumber,
  setAccountNumber,
  userInfo,
  handleChange,
  handleUpdate,
  handleOpenModal,
}) => {
  // 수정 가능 여부를 관리하는 상태 추가
  const [isEditable, setIsEditable] = useState(false);

  const handleEditToggle = () => {
    setIsEditable((prev) => !prev);
  };

  return (
    <FormBox>
      <Title>사업자 정보 수정</Title>
      <form>
        {/* 회사명 */}
        <InputGroup>
          <Label htmlFor="companyName">회사명</Label>
          <Input
            type="text"
            id="companyName"
            placeholder="회사명"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            disabled={!isEditable} // readOnly 속성 적용
          />
        </InputGroup>
        {/* 사업자 번호 */}
        <InputGroup>
          <Label htmlFor="businessNumber">사업자 번호</Label>
          <Input
            type="text"
            id="businessNumber"
            placeholder="사업자 번호"
            value={businessNumber}
            onChange={(e) => setBusinessNumber(e.target.value)}
            disabled={!isEditable}
          />
        </InputGroup>
        {/* 대표자명 */}
        <InputGroup>
          <Label htmlFor="representativeName">대표자명</Label>
          <Input
            type="text"
            id="representativeName"
            placeholder="대표자명"
            value={representativeName}
            onChange={(e) => setRepresentativeName(e.target.value)}
            disabled={!isEditable}
          />
        </InputGroup>
        {/* 업종 */}
        <InputGroup>
          <Label htmlFor="industryType">업종</Label>
          <Input
            type="text"
            id="industryType"
            placeholder="업종"
            value={industryType}
            onChange={(e) => setIndustryType(e.target.value)}
            disabled={!isEditable}
          />
        </InputGroup>
        {/* 업태 */}
        <InputGroup>
          <Label htmlFor="businessCategory">업태</Label>
          <Input
            type="text"
            id="businessCategory"
            placeholder="업태"
            value={businessCategory}
            onChange={(e) => setBusinessCategory(e.target.value)}
            disabled={!isEditable}
          />
        </InputGroup>
        {/* 주소 */}
        <InputGroup>
          <Label htmlFor="address">주소</Label>
          <Input
            type="text"
            id="address"
            placeholder="주소"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            disabled={!isEditable}
          />
        </InputGroup>
        {/* 은행 */}
        <InputGroup>
          <Label htmlFor="bank">은행</Label>
          <Select
            id="bank"
            name="bank"
            value={bank}
            onChange={handleChange}
            disabled={!isEditable} // Select에도 수정 가능 여부 적용
          >
            <option value="">은행선택</option>
            <option value="KB">KB국민은행</option>
            {/* 추가 은행 목록 */}
          </Select>
        </InputGroup>
        {/* 계좌번호 */}
        <InputGroup>
          <Label htmlFor="businessAccount">사업자 계좌번호</Label>
          <Input
            type="text"
            id="businessAccount"
            placeholder="사업자 계좌번호"
            value={accountNumber}
            onChange={(e) => setAccountNumber(e.target.value)}
            disabled={!isEditable}
          />
        </InputGroup>
        <ButtonGroup>
      
          {isEditable && (
            <Button type="button" onClick={handleUpdate}>
              정보 저장
            </Button>
          )}
            {/* 수정 버튼 추가 */}
          <Button type="button" onClick={handleEditToggle}>
            {isEditable ? '수정 취소' : '사업자 정보 수정'}
          </Button>
        </ButtonGroup>
      </form>
    </FormBox>
  );
};

export default BusinessInfoForm;